import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { lastValueFrom, Subscription, take } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAccountReceiptModel, IAccountReceiptVoidTransactionModel, IRentalItem, IRentalRecord, IVoidTransactionModel } from 'src/app/Shared/model/VoidTransactionModel';
import { IVendorsFilterOptions } from 'src/app/Shared/model/VendorsModel';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/general.service';
import { PaymentSettingsService } from 'src/app/services/PaymentSettings.service';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { VoidTransactionService } from 'src/app/services/VoidTransaction.service';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import Swal from 'sweetalert2';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { VendorSearchComponent } from 'src/app/Shared/vendor-search/vendor-search.component';
import printJS from 'print-js';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PosOpeningCashDrawerService } from 'src/app/services/pos_OpeningCashDrawer.service';
import { OpsOpeningCashDrawerAmount } from 'src/app/operations/ops-point-of-sales/ops-opening-cash-drawer-amount/ops-opening-cash-drawer-amount';
import { IOpenCashModel } from 'src/app/Shared/Interfaces/IPOSSettings';
import { DatePipe } from '@angular/common';
import { PaymentComponent } from 'src/app/Shared/payment/payment.component';
import { StripePaymentComponent } from 'src/app/Shared/stripe-payment/stripe-payment.component';
import { EPaymentGateway } from 'src/app/Shared/enum';
import { ASLicenseSettings } from 'src/app/Shared/model/GeneralModel';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
declare var bootstrap: any;

@Component({
  selector: 'app-ops-void-transaction',
  imports: [TopBarComponent, SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent, VendorSearchComponent, PaymentComponent, customCurrencyPipe, LoaderComponent, OpsOpeningCashDrawerAmount, StripePaymentComponent, WordReplacePipe],
  standalone: true,
  templateUrl: './ops-void-transaction.html',
  styleUrl: './ops-void-transaction.scss'
})
export class OpsVoidTransaction {
  isCollapsed: boolean = true;
  @ViewChild('gridTransactions', { static: false }) public gridTransactions: GridComponent;
  @ViewChild('gridItems', { static: false }) public gridItems: GridComponent;
  @ViewChild('gridPlans', { static: false }) public gridPlans: GridComponent;

  Showbackbutton = false;
  loaderIcon: Promise<boolean>;
  TransactionSearchForm: FormGroup;
  VoidTransactionForm: FormGroup;
  RefundCCForm: FormGroup;
  maxDate: Date = new Date();
  dayendRowData;
  dayendOrOpenCashNotSaved = false;
  hideOpenCashTopMenu = false;
  openCashNotSet = false;

  private subscriptions: Subscription[] = [];
  AccountReciepts: IAccountReceiptModel[] = [];

  vendorList;
  vendorDataFilterField: string = 'MarketVendorId';
  vendorDataFilterValue;
  filterData;
  marketId = 0;
  TransactionDetails: IAccountReceiptVoidTransactionModel;
  IsOperationPopUp = true;
  VendorFilterOption: IVendorsFilterOptions;
  response;
  RentalSettings;
  PaymentTransactionInfo;
  ProcessRefund = false;
  HasDeletedTransactions: boolean = false;
  OrderId = '';
  VerifoneId = 0;
  createRight: boolean;
  viewRight: boolean;
  viewRightFalseMessage;
  PaymentSettings;
  TaxSettings = {
    SecondTaxName: ''
  };
  IsStrip = false;
  IsOpenEdgeExpress = false;

  private OnlyNumber: RegExp = new RegExp(/^[0-9]*$/);
  DiscountHasTax = false;
  DiscountHasSecTax = false;
  RentalType = 0;
  thermalPrinting = false;
  printReceiptPopupOpen = false;
  uniqueSessionId = "";
  // LaserCopies = 0;
  // ThermalCopies = 0;
  BusinessType = 0;
  MarketDayHeaderName = 'Mkt Day';
  TradeShowEnabled = false;
  noLayout = false;

  public DropDownReceiptfields: Object = { text: 'AccountReceiptName', value: 'AccountReceiptId' };
  pdfUrl: SafeResourceUrl | null = null;

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  @ViewChild('printReceiptPopup', { static: false }) printReceiptPopup: ElementRef;

  constructor(private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private operationRentalService: OperationRentalService,
    private router: Router,
    private generalService: GeneralService,
    private vendorService: VendorService,
    private paymentService: PaymentSettingsService,
    private VoidTransactionService: VoidTransactionService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private sanitizer: DomSanitizer,
    private posOpeningCashDrawerService: PosOpeningCashDrawerService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.getMarketCurrentTime();
    this.checkOpenCashSavedForTrans();
    this.getASCloudLicenseSettings();
    this.subscriptions.push(this.operationRentalService.getDefaultMarketId().subscribe((res: any) => {
      if (res) {
        this.marketId = res;
      }
    }));

    this.GetPaymentSettings();

    this.OrderId = '';
    this.TransactionSearchForm = this.formBuilder.group(
      {
        ByReceipt: [true],
        ReceiptId: [0],
        ReceiptDate: [this.maxDate],
        MarketVendorId: [''],
        VendorId: [0],
        MarketId: [0],
        VendorName: ['']
      });

    this.VoidTransactionForm = this.formBuilder.group(
      {
        ReceiptId: [0, [Validators.required]],
        ReceiptDate: [Date],
        MarketVendorId: [''],
        vendorId: [0],
        ReasonToVoid: ['', [Validators.required]],
        DisplayReceipt: [false],
        PrintReceipt: [false],
        EmailReceipt: [false],
        RentalRecords: [{} as IRentalRecord],
        RentalItems: [{} as IRentalItem]
      });

    this.RefundCCForm = this.formBuilder.group(
      {
        SeqVendorId: [0, [Validators.required]],
        MarketVendorId: [""],
        TransactionType: [""],
        RefundSale: [false],
        OrginalCCrefno: [""],
        TotalCCAmount: [0],
        ReceiptId: [0, [Validators.required]],
        GatewayType: [""]
      });

    this.subscriptions.push(this.TransactionSearchForm.get('ReceiptDate').valueChanges.subscribe(value => {
      if (this.TransactionSearchForm.get('ByReceipt').value) {
        this.TransactionSearchForm.patchValue({
          MarketVendorId: '',
          VendorId: 0,
          VendorName: '',
        })
      }
      this.GetReceipts();
    }))

    this.subscriptions.push(this.TransactionSearchForm.get('ReceiptId').valueChanges.subscribe(value => {
      const selectedReceipt = this.AccountReciepts.find(x => x.AccountReceiptId == this.TransactionSearchForm.get('ReceiptId').value);
      this.TransactionSearchForm.patchValue({
        MarketVendorId: selectedReceipt.MarketVendorId,
        VendorName: selectedReceipt.vendorName,
        VendorId: selectedReceipt.vendorId
      })
      this.LoadTransactions();
    }));

    this.TransactionDetails = {
      RentalRecords: [],
      RentalItems: [],
      DiscountPlans: [],
      RentalOtherCharges: 0,
      RentalCharges: 0,
      RefundAmount: 0,
      DepositAmount: 0,
      SalesTax: 0,
      SecLvlSalesTax: 0,
      Discount: 0,
      LateFee: 0,
      CashAdjustment: 0,
      CheckAdjustmentAmount: 0,
      CheckNumber: "",
      CCAdjustmentAmount: 0,
      DirectDebitPayment: 0,
      IsPaymentTransaction: false,
      MarketVendorId: 0,
      VendorId: 0,
      ReceiptId: 0,
      CanVoidTransaction: false,
      ShowRentalStart: false,
      DisplayReceipt: false,
      PrintReceipt: false,
      SalesTaxEnabled: false,
      SecLvlSalesTaxEnabled: false,
      ReceiptDate: null,
      RentalItemPrefix: "",
      RentalItemTableName: "",
      RentalPrefix: "",
      RentalTableName: "",
      IsLottery: false,
      LotteryNo: 0,
      IsPaid: false
    }

    this.VendorFilterOption = {
      All: true,
      Current: false,
      Inactive: false,
      PageModel: {
        pageCount: 1,
        pageSize: 20
      }

    }

    //this.GetUserGroupPermissions();
    this.subscriptions.push(this.operationRentalService.getDefaultMarketId().subscribe((res: any) => {
      if (res) {
        this.marketId = res;
      }
    }));
    // this.CheckTradeShowEnabled();
    // this.GetRentalSettings()
    // this.GetPaymentSettings();
    // this.getTaxSettings();

    const tabId = sessionStorage.getItem('tabId');
    const sessionKey = `UniqueSessionId-${tabId}`;
    this.uniqueSessionId = localStorage.getItem(sessionKey);
  }

  getMarketCurrentTime(): void {
    this.generalService.GetMarketCurrentTime()
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.maxDate = new Date(res);
          this.TransactionSearchForm.patchValue({
            ReceiptDate: this.maxDate
          });
        },
        error: (err) => {
        }
      });
  }

  checkOpenCashSavedForTrans() {
    this.posOpeningCashDrawerService.checkOpenCashSavedForTransaction()
      .pipe(take(1))
      .subscribe({
        next: (response: IOpenCashModel) => {
          this.loaderIcon = Promise.resolve(false);
          var posOpenCashDetails = response;
          if (posOpenCashDetails && posOpenCashDetails.PreviousEODNotProcessedDate) {
            const dateEODNotProcessed = posOpenCashDetails.PreviousEODNotProcessedDate.substring(5, 7) + '/' + posOpenCashDetails.PreviousEODNotProcessedDate.substring(8, 10) + '/' + posOpenCashDetails.PreviousEODNotProcessedDate.substring(0, 4);
            posOpenCashDetails.PreviousEODNotProcessedDate.substring(0, 10)
            Swal.fire({
              text: $localize`:@@MsgDayendForDateNotSubmitted:The Day end for date: ${dateEODNotProcessed} is not submitted!`,
              icon: 'warning',
              confirmButtonText: $localize`:@@Ok:Ok`,
              didClose: async () => {
                const result = await Swal.fire({
                  title: $localize`Confirm`,
                  text: $localize`Are you sure you want to process dayend for ${dateEODNotProcessed}`,
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonText: $localize`Yes`,
                  cancelButtonText: $localize`No`
                });

                if (result.isConfirmed) {
                  const userData = await lastValueFrom(
                    this.generalService.getLoggedInUserAndTerminal().pipe(take(1))
                  );
                  this.dayendRowData = {
                    UserId: userData.UserId,
                    Terminal: userData.TerminalName,
                    OpeningCashDate: this.datePipe.transform(posOpenCashDetails.PreviousEODNotProcessedDate, "yyyy-MM-dd")
                  }
                  this.generalService.setDayendRowDataForTrans(this.dayendRowData);
                  var url = 'ops/pos/day-end-process/trans';
                  this.router.navigate([url]);
                } else {
                  this.dayendOrOpenCashNotSaved = true;
                }
              }
            });
          }
          else if (!posOpenCashDetails || posOpenCashDetails.Id == 0) {
            this.hideOpenCashTopMenu = true;
            this.openCashNotSet = true
            this.openModalById('modalOpenCash')
          }
        }
      })
  }

  openCashSaved(val) {
    this.openCashNotSet = false;
    this.closeModalById('modalOpenCash');
  }

  btnCloseOpenCash() {
    this.dayendOrOpenCashNotSaved = true;
    this.closeModalById('modalOpenCash');
  }

  ngAfterViewInit() {
    this.GetReceipts();
  }

  getASCloudLicenseSettings(): void {
    const licenseSettings = this.generalService.ASLicenseSettings;
    if (licenseSettings !== null) {
      this.noLayout = licenseSettings.NoLayout ?? false;
      return;
    }

    this.generalService.getASCloudLicenseSettings().pipe(take(1)).subscribe({
      next: (res: ASLicenseSettings) => {
        this.generalService.ASLicenseSettings = res;
        this.noLayout = res.NoLayout ?? false;
      },
      error: () => {
        this.noLayout = false;
      }
    });
  }

  GetReceipts() {
    this.AccountReciepts = [];
    this.ClearTransaction();

    const receiptsearch = {
      MarketVendorId: this.TransactionSearchForm.get('MarketVendorId').value == '' ? '' : this.TransactionSearchForm.get('MarketVendorId').value,
      date: this.TransactionSearchForm.get('ReceiptDate').value,
      TradeShow: this.BusinessType == 1 ? true : false
    }
    this.subscriptions.push(this.VoidTransactionService.GetReceipts(receiptsearch).subscribe((res: any) => {

      if (res.length != 0) {
        this.AccountReciepts = res;
        this.TransactionSearchForm.patchValue({
          ReceiptId: this.AccountReciepts[0].AccountReceiptId,
          MarketVendorId: this.AccountReciepts[0].MarketVendorId,
          VendorName: this.AccountReciepts[0].vendorName,
          VendorId: this.AccountReciepts[0].vendorId
        });
      } else {
        if (this.TransactionSearchForm.get('MarketVendorId').value != '') {
          this.toastr.info($localize`No Transactions exist for this Vendor`, $localize`Retry`, this.sharedHTMLSettings.ToasterConfig);
        }
      }
    }));
  }

  ClearTransaction() {
    this.VoidTransactionForm.patchValue(
      {
        ReceiptId: 0,
        ReceiptDate: null,
        MarketVendorId: '',
        VendorId: 0,
        ReasonToVoid: '',
        DisplayReceipt: false,
        PrintReceipt: false,
        RentalRecords: [{} as IRentalRecord],
        RentalItems: [{} as IRentalItem]
      });

    this.TransactionDetails = {
      RentalRecords: [],
      RentalItems: [],
      DiscountPlans: [],
      RentalOtherCharges: 0,
      RentalCharges: 0,
      RefundAmount: 0,
      DepositAmount: 0,
      SalesTax: 0,
      SecLvlSalesTax: 0,
      Discount: 0,
      LateFee: 0,
      CashAdjustment: 0,
      CheckAdjustmentAmount: 0,
      CheckNumber: "",
      CCAdjustmentAmount: 0,
      DirectDebitPayment: 0,
      IsPaymentTransaction: false,
      MarketVendorId: 0,
      VendorId: 0,
      ReceiptId: 0,
      CanVoidTransaction: false,
      ShowRentalStart: false,
      DisplayReceipt: false,
      PrintReceipt: false,
      SalesTaxEnabled: false,
      SecLvlSalesTaxEnabled: false,
      ReceiptDate: null,
      RentalItemPrefix: "",
      RentalItemTableName: "",
      RentalPrefix: "",
      RentalTableName: "",
      IsLottery: false,
      LotteryNo: 0,
      IsPaid: false
    }
    this.loaderIcon = Promise.resolve(false);
  }

  LoadTransactions() {
    this.ClearTransaction();
    this.ProcessRefund = false;
    this.loaderIcon = Promise.resolve(true);

    this.subscriptions.push(this.VoidTransactionService.LoadTransctionDetails(this.TransactionSearchForm.get('ReceiptId').value).subscribe((res: any) => {
      if (res) {
        this.RentalType = res.RentalType;
        this.TransactionDetails.MarketVendorId = res.MarketVendorId;
        this.TransactionDetails.VendorId = res.VendorId;
        this.TransactionDetails.ReceiptId = res.ReceiptId;
        this.TransactionDetails.RentalRecords = res.RentalRecords;
        this.TransactionDetails.RentalItems = res.RentalItems;
        this.TransactionDetails.DiscountPlans = res.DiscountPlans;
        if (res.DiscountPlans != null) {
          this.DiscountHasTax = res.DiscountPlans.some(x => x.Tax != 0);
          this.DiscountHasSecTax = res.DiscountPlans.some(x => x.SecLvlTax != 0);
        } else {
          this.DiscountHasTax = false;
          this.DiscountHasSecTax = false;
        }

        if (res.HasDeletedTransactions) {
          this.HasDeletedTransactions = true;
        } else {
          this.HasDeletedTransactions = false;
        }

        this.TransactionDetails.CCAdjustmentAmount = res.CCAdjustmentAmount;
        this.TransactionDetails.CanVoidTransaction = res.CanVoidTransaction;
        this.TransactionDetails.CashAdjustment = res.CashAdjustment;
        this.TransactionDetails.CheckAdjustmentAmount = res.CheckAdjustmentAmount;
        this.TransactionDetails.CheckNumber = res.CheckNumber;
        this.TransactionDetails.DepositAmount = res.DepositAmount;
        this.TransactionDetails.DirectDebitPayment = res.DirectDebitPayment;
        this.TransactionDetails.Discount = res.Discount;
        this.TransactionDetails.IsPaymentTransaction = res.IsPaymentTransaction;
        this.TransactionDetails.LateFee = res.LateFee;
        this.TransactionDetails.RefundAmount = res.RefundAmount;
        this.TransactionDetails.RentalCharges = res.RentalCharges;
        this.TransactionDetails.RentalOtherCharges = res.RentalOtherCharges;
        this.TransactionDetails.SalesTax = res.SalesTax;
        this.TransactionDetails.SecLvlSalesTax = res.SecLvlSalesTax;
        this.TransactionDetails.ShowRentalStart = res.ShowRentalStart;
        this.TransactionDetails.DisplayReceipt = res.DisplayReceipt;
        this.TransactionDetails.PrintReceipt = res.PrintReceipt;
        this.TransactionDetails.SalesTaxEnabled = res.SalesTaxEnabled;
        this.TransactionDetails.SecLvlSalesTaxEnabled = res.SecLvlSalesTaxEnabled;
        this.TransactionDetails.ReceiptDate = res.ReceiptDate;
        this.TransactionDetails.RentalTableName = res.RentalTableName;
        this.TransactionDetails.RentalPrefix = res.RentalPrefix;
        this.TransactionDetails.RentalItemTableName = res.RentalItemTableName;
        this.TransactionDetails.RentalItemPrefix = res.RentalItemPrefix;
        this.TransactionDetails.IsLottery = res.IsLottery;
        this.TransactionDetails.LotteryNo = res.LotteryNo;
        this.TransactionDetails.IsPaid = res.IsPaid;

        this.loaderIcon = Promise.resolve(false);

        //this.getPrinterAndCustomSettings();
        this.getRentalPaymentSettings();
      } else {
        this.toastr.error($localize`something went wrong!`, $localize`error`, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    }));

    this.VoidTransactionForm.patchValue({
      ReceiptId: this.TransactionDetails.ReceiptId,
      ReceiptDate: this.TransactionDetails.ReceiptDate,
      MarketVendorId: this.TransactionDetails.MarketVendorId,
      VendorId: this.TransactionDetails.VendorId,
      DisplayReceipt: this.TransactionDetails.DisplayReceipt,
      PrintReceipt: this.TransactionDetails.PrintReceipt
    })
  }

  get shouldShowBalanceColumns(): boolean {
    return this.TransactionDetails.IsPaymentTransaction || this.TransactionDetails.IsPaid;
  }

  getVendorDataUsingFilter() {
    this.filterData =
    {
      vendorDataFilterField: this.vendorDataFilterField,
      vendorDataFilterValue: this.vendorDataFilterValue
    }
  }

  vendorSearchResult(vendorData) {
    this.TransactionSearchForm.patchValue({
      MarketVendorId: vendorData.marketVendorId,
      VendorId: vendorData.vendorId,
      VendorName: vendorData.vendorName,
    });
    this.GetReceipts();
  }

  clearVendorSearch() {
    this.TransactionSearchForm.patchValue({
      MarketVendorId: '',
      VendorId: 0,
      VendorName: '',
    })
    this.GetReceipts();
  }

  CheckCCRefund() {
    if (this.openCashNotSet || this.dayendOrOpenCashNotSaved) {
      Swal.fire({
        text: `Please enter opening cash drawer amount in 'Opg Cash - Drawer Amt' module and then save the record..!`,
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }
    if (this.PaymentSettings.McsBitProcessCreditCardOnline && this.TransactionDetails.CCAdjustmentAmount > 0) {
      if (this.TransactionSearchForm.get('ReceiptId').invalid || this.TransactionSearchForm.get('ReceiptId').value == 0) {
        this.toastr.error($localize`Select a valid receipt`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
        return;
      }
      if (this.VoidTransactionForm.get('ReasonToVoid').invalid || this.VoidTransactionForm.get('ReasonToVoid').value.trim() == "") {
        this.toastr.error($localize`Enter a reason to void this receipt`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
        return;
      }
      this.VoidTransactionForm.patchValue({
        RentalRecords: this.TransactionDetails.RentalRecords,
        RentalItems: this.TransactionDetails.RentalItems,
      });
      this.subscriptions.push(
        this.VoidTransactionService.GetRefundCCDetails(
          this.TransactionSearchForm.get('ReceiptId').value
        )
          .subscribe((res: any) => {

            if (res) {

              this.RefundCCForm.setValue({
                SeqVendorId: res.SeqVendorId,
                MarketVendorId: this.TransactionSearchForm.get('MarketVendorId').value,
                TransactionType: res.TransactionType,
                RefundSale: res.RefundSale,
                OrginalCCrefno: res.OrginalCCrefno,
                TotalCCAmount: res.TotalCCAmount,
                ReceiptId: this.TransactionSearchForm.get('ReceiptId').value,
                GatewayType: res.GatewayType
              });

              this.openModalById('RefundModal');
            }
            else {

              this.toastr.error(
                $localize`Payment Details Error`,
                $localize`Failed`,
                this.sharedHTMLSettings.ToasterConfig
              );
            }
          })
      );
    } else {
      this.ConfirmVoid();
    }
  }

  Refund() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.VoidTransactionService.GetTransactionByReceiptId(this.TransactionSearchForm.get('ReceiptId').value).subscribe((res: any) => {
      if (res) {
        this.PaymentTransactionInfo = res;
        this.ProcessRefund = true;
        if (this.IsStrip) {
          this.loaderIcon = Promise.resolve(false);
        }
      } else {
        this.toastr.error($localize`Payment Details Error`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
        this.ProcessRefund = false;
        this.loaderIcon = Promise.resolve(false);
        return;
      }
    }));
  }

  ConfirmVoid() {
    if (this.TransactionSearchForm.get('ReceiptId').invalid || this.TransactionSearchForm.get('ReceiptId').value == 0) {
      this.toastr.error($localize`Select a valid receipt`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
      return;
    }
    if (this.VoidTransactionForm.get('ReasonToVoid').invalid || this.VoidTransactionForm.get('ReasonToVoid').value == "") {
      this.toastr.error($localize`Enter a reason to void this receipt`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
      return;
    }

    this.VoidTransactionForm.patchValue({
      RentalRecords: this.TransactionDetails.RentalRecords,
      RentalItems: this.TransactionDetails.RentalItems,
    });

    Swal.fire({
      title: $localize`Voiding`,
      text: $localize`Are you sure you want to void this transaction?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.value) {
        this.VoidTransaction()
      } else {
        this.toastr.warning($localize`Cancelled`, ``, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
        return;
      }

    });
  }

  async VoidTransaction() {
    this.loaderIcon = Promise.resolve(true);

    const userData = await lastValueFrom(
      this.generalService.getLoggedInUserAndTerminal().pipe(take(1))
    );

    const terminalName = userData?.TerminalName;

    if (this.VoidTransactionForm.get('ReasonToVoid').value.trim() == '') {
      this.toastr.error($localize`Void reason can't be empty`, $localize``, this.sharedHTMLSettings.ToasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const VoidTransactionModel: IVoidTransactionModel = {
      RentalRecords: this.VoidTransactionForm.get('RentalRecords').value,
      RentalItems: this.VoidTransactionForm.get('RentalItems').value,
      IsPaymentTransaction: this.TransactionDetails.IsPaymentTransaction,
      MarketVendorId: this.TransactionSearchForm.get('MarketVendorId').value,
      VendorId: this.TransactionSearchForm.get('VendorId').value,
      ReceiptId: this.TransactionSearchForm.get('ReceiptId').value,
      CanVoidTransaction: this.TransactionDetails.CanVoidTransaction,
      DisplayReceipt: this.VoidTransactionForm.get('DisplayReceipt').value,
      PrintReceipt: this.VoidTransactionForm.get('PrintReceipt').value,
      SalesTaxEnabled: this.TransactionDetails.SalesTaxEnabled,
      SecLvlSalesTaxEnabled: this.TransactionDetails.SecLvlSalesTaxEnabled,
      ReceiptDate: this.TransactionSearchForm.get('ReceiptDate').value,
      ReasonToVoid: this.VoidTransactionForm.get('ReasonToVoid').value,
      RentalTableName: this.TransactionDetails.RentalTableName,
      RentalPrefix: this.TransactionDetails.RentalPrefix,
      RentalItemTableName: this.TransactionDetails.RentalItemTableName,
      RentalItemPrefix: this.TransactionDetails.RentalItemPrefix,
      OrderId: this.OrderId,
      VerifoneId: this.VerifoneId,
      RentalType: this.RentalType,
      IsLottery: this.TransactionDetails.IsLottery,
      LotteryNo: this.TransactionDetails.LotteryNo,
      TerminalName: terminalName
    }
    var voidId = 0;
    this.subscriptions.push(this.VoidTransactionService.VoidTransction(VoidTransactionModel).subscribe(async (res: any) => {
      this.response = res;
      if (this.response.Success) {
        this.toastr.success($localize`Transaction voided successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        this.ClearTransaction();
        this.clearVendorSearch();
        this.TransactionSearchForm.patchValue({
          MarketVendorId: '',
          VendorName: '',
        });
        voidId = this.response.Id;

        this.loaderIcon = Promise.resolve(false);

        var payload = {
          VendorId: VoidTransactionModel.VendorId,
          AccountReceiptId: voidId,
          RentalType: VoidTransactionModel.RentalType,
          PaymentOnly: VoidTransactionModel.IsPaymentTransaction,
          DocumentId: 113,
          VendorHistory: false,
          Deposit: false,
          DisplayBillNum: false,
          MerchantCopy: false,
          CustomerCopy: false,
          SignBase64: '',
          LaserThermalReceipt: false
        }

        if (VoidTransactionModel.PrintReceipt) {
          // var thermalNoOfCopies = this.ThermalCopies

          // if (thermalNoOfCopies && thermalNoOfCopies > 0) {
          //   const customProtocolUrl = 'silentprinter://?methodname=voidtransactionreceipt&param1=' + res.Id + '&param2=' + this.RentalType + '&param3=' + VoidTransactionModel.VendorId + '&param4=' + this.TransactionDetails.IsPaymentTransaction + '&param5=' + thermalNoOfCopies + '&uniqueSessionId=' + this.uniqueSessionId;
          //   window.location.href = customProtocolUrl;
          // }

          // this.operationRentalService.GetRentalPrintReceiptNoOfCopies(1).subscribe((response: string) => {
          //   const customProtocolUrl = 'silentprinter://?methodname=voidtransactionreceipt&param1=' + res.Id + '&param2=' + this.RentalType +'&param3=' + VoidTransactionModel.VendorId + '&param4=' +  this.TransactionDetails.IsPaymentTransaction + '&param5=' + response + '&uniqueSessionId=' + this.uniqueSessionId;
          //   window.location.href = customProtocolUrl;
          // });

          this.printVoidTransactionReceipt(payload);
        }
        if (VoidTransactionModel.DisplayReceipt) {
          this.viewVoidTransactionReceipt(payload);
        }
      }
      else {
        if (this.response.Message == 'Deleted') {
          Swal.fire({
            title: $localize`Failed `,
            text: $localize`Voiding the Transaction is not possible. One or more records of the transaction is deleted. `,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: $localize`OK`,
          }).then((result) => {
            if (result.value) {
              return
            }
          });
        } else {
          Swal.fire({
            title: $localize`Failed `,
            text: $localize`${this.response.Message}`,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: $localize`OK`,
          }).then((result) => {
            if (result.value) {
              return
            }
          });
          // this.toastr.error($localize`${this.response.Message}`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  private printVoidTransactionReceipt(payload: any) {
    this.loaderIcon = Promise.resolve(true);

    this.vendorService.DisplayVoidReceipt(payload).subscribe({
      next: (res: any) => {
        const pdfDataUrl = res?.Message;
        if (!pdfDataUrl?.startsWith('data:application/pdf;base64,')) {
          this.loaderIcon = Promise.resolve(false);
          Swal.fire('Error', 'Invalid PDF data', 'error');
          return;
        }

        const pdfBase64 = pdfDataUrl.split(',')[1];
        this.loaderIcon = Promise.resolve(false);

        printJS({
          printable: pdfBase64,
          type: 'pdf',
          base64: true
        });
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
        Swal.fire('Error', 'Failed to print receipt', 'error');
      }
    });
  }

  private viewVoidTransactionReceipt(payload: any) {
    this.loaderIcon = Promise.resolve(true);
    this.pdfUrl = null;

    this.vendorService.DisplayVoidReceipt(payload).subscribe({
      next: (res: any) => {
        const pdfDataUrl = res?.Message;
        if (!pdfDataUrl?.startsWith('data:application/pdf;base64,')) {
          this.loaderIcon = Promise.resolve(false);
          Swal.fire('Error', 'Invalid PDF data', 'error');
          return;
        }

        const base64 = pdfDataUrl.split(',')[1];
        const blob = this.base64ToBlob(base64, 'application/pdf');
        this.pdfUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(blob)
          );

        this.loaderIcon = Promise.resolve(false);

        const modalEl = document.getElementById('viewReceiptModal');
        if (modalEl) {
          const modal =
            (window as any).bootstrap.Modal.getOrCreateInstance(modalEl);
          modal.show();
        }
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
        Swal.fire('Error', 'Failed to load receipt', 'error');
      }
    });
  }

  private base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type });
  }

  PaymentRespond(e) {
    if (e.PaymentSuccess) {
      this.OrderId = e.OrderId;
      this.VerifoneId = e.VerifoneId;
      this.ProcessRefund = false;
      this.closeModalById('RefundModal');
      this.VoidTransaction();
    } else {
      this.ProcessRefund = false;
      this.closeModalById('RefundModal');
      this.toastr.error($localize`Online refund failed, retry after sometime`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
      this.loaderIcon = Promise.resolve(false);
    }
  }

  MarketVendorIdChange() {
    // if (!this.OnlyNumber.test(this.TransactionSearchForm.get('MarketVendorId').value)) {
    //   this.TransactionSearchForm.patchValue({
    //     MarketVendorId : ''
    //   });
    //   this.toastr.info($localize`Not allowed`,$localize`Retry`, this.sharedHTMLSettings.ToasterConfig);
    //   this.clearVendorSearch()
    //   return
    // }
    if (!this.TransactionSearchForm.get('ByReceipt').value) {

      this.loaderIcon = Promise.resolve(true);

      if (this.TransactionSearchForm.get('MarketVendorId').value != "") {
        this.subscriptions.push(this.vendorService.GetVendorByMarketVendorId(this.TransactionSearchForm.get('MarketVendorId').value).subscribe((res: any) => {
          const result = res.body;
          if (result != null) {
            this.TransactionSearchForm.patchValue({
              VendorId: result.VenSeqVendorId,
              VendorName: result.VenTxtVendorName,
            })
            if (result.VenSeqVendorId == 0) {
              this.ClearTransaction();
              this.toastr.info($localize`Vendor not found`, $localize`Retry`, this.sharedHTMLSettings.ToasterConfig);
              return;
            }
            this.GetReceipts();
          }
          else {
            this.ClearTransaction();
            this.toastr.info($localize`Vendor not found`, $localize`Retry`, this.sharedHTMLSettings.ToasterConfig);
            return;
          }
        }));
        this.loaderIcon = Promise.resolve(false);
      } else {
        this.loaderIcon = Promise.resolve(false);
        this.TransactionSearchForm.patchValue({
          VendorId: 0,
          VendorName: '',
        })
        this.ClearTransaction();
        this.clearVendorSearch();
      }
    }
  }

  closeReceiptDisplay() {
    //this.printReceipt.hide();
    this.closeModalById('printReceiptPopup');
    this.GetReceipts();
  }

  afterPrintHandler(): void {
    this.closeReceiptDisplay();
  }

  getRentalPaymentSettings() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.operationRentalService.getRentalSettings().subscribe((res: any) => {
      if (res) {
        this.thermalPrinting = res.PrintThermalVoid;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  GetPaymentSettings() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.paymentService.GetOnlinePaymentSettings().subscribe((res: any) => {
      this.PaymentSettings = res;
      //added by sudarshan for Stripe payment
      if (res.McsIntPaymentGateway == EPaymentGateway.Stripe) {
        this.IsStrip = true;
      } else if (res.McsIntPaymentGateway == EPaymentGateway.OpenEdgeExpress) {
        this.IsOpenEdgeExpress = true;
      }
      this.loaderIcon = Promise.resolve(false);
    }));

    this.loaderIcon = Promise.resolve(false);
  }

  closeModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
    document.body.classList.remove('modal-open');

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  openModalById(modalId) {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const modal = new bootstrap.Modal(
      document.getElementById(modalId)!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    modal.show();
  }

  Close() {
    this.router.navigate(['/dashboard']);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
